import { render, staticRenderFns } from "./HighChartsTcpaHistory.vue?vue&type=template&id=23c90acf&scoped=true"
import script from "./HighChartsTcpaHistory.vue?vue&type=script&lang=js"
export * from "./HighChartsTcpaHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c90acf",
  null
  
)

export default component.exports